import React, { useEffect } from "react";

import FlexWrapper from "../../components/ui/Container/FlexWrapper/styled";
import ProfessionCategories from "../../components/ProfessionCategories";
import Professions from "../../components/Professions";
import Props from "./props";
import styled from "styled-components";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";
import useProfessionsAndCategories from "./../../../state/hooks/ProfessionHooks/useProfessionsAndCategories";

const All: React.FC<Props> = props => {
    const { setAppTitle } = useAppTitle();
    useEffect(() => {
        setAppTitle(props.title);
        return () => {
            setAppTitle("");
        };
    }, [setAppTitle, props.title]);
    useProfessionsAndCategories();
    return (
        <FlexWrapper>
            <ProfessionCategories />
            <Container>
                <Professions />
            </Container>
        </FlexWrapper>
    );
};

export default All;

const Container = styled.div`
    display: flex;
    flex: 1;
    padding-left: 22rem;
    min-height: calc(100vh - 4.5rem);
`;
